import { css } from 'styled-components';

export default css`
  padding: 0;
  .driver-instructions-value {
    font-family: 'Noto Sans';
  }
`;
